// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1g0XZ","productName":"Table_productName__2738m"};